export const DIALOG_STATUSES = {
  ADD: 'add',
  SELECT: 'select',
  EDIT: 'edit',
  CLOSED: 'closed',
};
export type DialogStatus = typeof DIALOG_STATUSES[keyof typeof DIALOG_STATUSES];

export const PEOPLE_LIMIT = 4;

export const PRIMARY_COLOR = '#19967D';
export const PRIMARY_DARK_COLOR = '#157F6A';
export const SECONDARY_COLOR = '#0C7CBA';
export const SECONDARY_DARK_COLOR = '#0B6A9E';
export const DISCARD_COLOR = '#C92D39';
export const DISCARD_DARK_COLOR = '#B22934';
export const INDICATOR_COLOR = '#EF8D22';
